'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEntitiesSlice = getEntitiesSlice;
exports.getEntities = getEntities;
exports.getEntitiesBy = getEntitiesBy;
exports.getEntity = getEntity;

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _entmanDenormalizr = require('entman-denormalizr');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEntitiesSlice(state) {
  return state.entities;
}

function getEntities(state, schema, ids, raw) {
  var key = schema.key;
  var entitiesState = getEntitiesSlice(state);
  var entities = ids ? (0, _values2.default)(entitiesState[key]).filter(function (e) {
    return ids.includes(e.id);
  }) : (0, _values2.default)(entitiesState[key]);

  if (raw) {
    return entities;
  }

  return entities.map(function (e) {
    return (0, _entmanDenormalizr.denormalize)(e, entitiesState, schema);
  });
}

function getEntitiesBy(state, schema) {
  var by = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var raw = arguments[3];

  var byKey = Object.keys(by)[0];
  var value = by[byKey];
  var key = schema.key;
  var entitiesState = getEntitiesSlice(state);
  var entities = (0, _values2.default)((0, _pickBy2.default)(entitiesState[key], function (e) {
    return e[byKey] === value;
  }));

  if (raw) {
    return entities;
  }

  return entities.map(function (e) {
    return (0, _entmanDenormalizr.denormalize)(e, entitiesState, schema);
  });
}

function getEntity(state, schema, id, raw) {
  if (!id) throw new Error('Required param `id` is missing');
  var key = schema.key;
  var entitiesState = getEntitiesSlice(state);
  var entities = entitiesState[key];
  if ((0, _isEmpty2.default)(entities)) return null;
  var entity = entities[id];

  if (raw) {
    return entity;
  }

  return (0, _entmanDenormalizr.denormalize)(entity, entitiesState, schema);
}